import React from "react";
import { Plus } from "lucide-react";
import { Button } from "../../ui/button";

interface AddSectionButtonProps {
  onAddSection: () => void;
}

export default function AddSectionButton({ onAddSection }: AddSectionButtonProps) {
  return (
    <Button
      variant="outline"
      onClick={onAddSection}
      className="my-3 flex-1 bg-muted border-dashed border-border text-muted-foreground hover:text-foreground w-full"
    >
      <Plus className="h-5 w-5 mr-2" />
      Add New Section
    </Button>
  );
} 